import { ContentState } from './types'

export const gradesTree = (state: ContentState) => state.gradesTree

export const contentCache = (state: ContentState) => state.contentCache

export const bookTree = (state: ContentState) => state.bookTree

export const filters = (state: ContentState) => state.filters
